var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('my-header',{attrs:{"page":'page_not_found'}}),_vm._v(" "),_c('div',{staticClass:"pd20",attrs:{"id":"page-not-found"}},[_c('p',[_vm._v(_vm._s(_vm._f("translate")('Page Not Found')))]),_vm._v(" "),_c('img',{attrs:{"src":"/static/images/warning.svg"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c1cef0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/PageNotFound.vue
// module id = null
// module chunks = 